import {
  buildMessagesReportFetchKey,
  formatMessagesReportBoundaryDate,
  socialNetworkTypeIdToChartKey,
} from "./messagesReport"

export { formatMessagesReportBoundaryDate, buildMessagesReportFetchKey } from "./messagesReport"

export const TIME_OF_DAY_SLOTS = ["9AM-5PM", "5PM-12AM", "12AM-5AM"]

/** Shared colors for messages + alerts donuts and the legend (must stay aligned). */
export const TIME_OF_DAY_CHART_SERIES = [
  { key: "9AM-5PM", label: "9AM-5PM", colorVar: "--chart-1" },
  { key: "5PM-12AM", label: "5PM-12AM", colorVar: "--chart-5" },
  { key: "12AM-5AM", label: "12AM-5AM", colorVar: "--chart-4" },
]

const TIME_SLOT_ALIASES = new Map([
  ["9AM-5PM", "9AM-5PM"],
  ["5AM-5PM", "9AM-5PM"],
  ["5PM-12AM", "5PM-12AM"],
  ["12AM-5AM", "12AM-5AM"],
])

function normalizeTimeSlotKey(raw) {
  const compact = String(raw ?? "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase()
  if (!compact) return null
  if (TIME_SLOT_ALIASES.has(compact)) return TIME_SLOT_ALIASES.get(compact)
  if (TIME_OF_DAY_SLOTS.includes(compact)) return compact
  return null
}

function resolveRowTimeSlot(row) {
  const candidates = [
    row?.timeSlot,
    row?.time_slot,
    row?.timeSlotName,
    row?.time_slot_name,
    row?.slot,
  ]
  for (const candidate of candidates) {
    const key = normalizeTimeSlotKey(candidate)
    if (key) return key
  }
  return null
}

/**
 * @param {Array<{
 *   timeSlot?: string,
 *   percentage?: number,
 *   count?: number,
 *   socialNetworkTypeId?: number,
 * }>} rows
 * @param {{
 *   platformKeysFilter?: string[] | null,
 *   socialNetworkTypes?: Array<{ id?: number, description?: string, name?: string }>,
 * }} options
 */
export function buildTimeOfDayFromRows(rows, options = {}) {
  const safeRows = Array.isArray(rows) ? rows : []
  const { platformKeysFilter, socialNetworkTypes = [] } = options

  const countsBySlot = new Map()
  for (const slot of TIME_OF_DAY_SLOTS) {
    countsBySlot.set(slot, 0)
  }

  for (const row of safeRows) {
    const slot = resolveRowTimeSlot(row)
    if (!slot) continue

    if (platformKeysFilter?.length) {
      const platformKey = socialNetworkTypeIdToChartKey(
        socialNetworkTypes,
        row?.socialNetworkTypeId,
      )
      if (!platformKey || !platformKeysFilter.includes(platformKey)) continue
    } else {
      const platformKey = socialNetworkTypeIdToChartKey(
        socialNetworkTypes,
        row?.socialNetworkTypeId,
      )
      if (!platformKey) continue
    }

    const count = Number(row?.count ?? row?.messageCount) || 0
    countsBySlot.set(slot, (countsBySlot.get(slot) || 0) + count)
  }

  const total = [...countsBySlot.values()].reduce((sum, n) => sum + n, 0)

  const entries = TIME_OF_DAY_SLOTS.map((name) => {
    const count = countsBySlot.get(name) || 0
    const value = total > 0 ? (count / total) * 100 : 0
    return { name, value, count }
  })

  const top =
    entries.length > 0
      ? entries.reduce((best, entry) =>
          entry.value > (best?.value ?? -1) ? entry : best,
        entries[0])
      : null

  return { entries, total, top }
}
